import { Fragment, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useUpdateFavoritesInfoMutation } from '../../../Account/api';
import { setProfile } from '../../../Account/state/profileSlice';
import CLOSE from '../../../assets/imgs/icon/close.svg';
import { Loading } from '../../../components/Loading';
import { setBirthdaySet } from '../../../domains/Auth/slice';
import { Button } from '../../../GlobalComponents/Button';
import { ErrorMessage } from '../../../GlobalComponents/ErrorMessage';
import { Flex } from '../../../GlobalComponents/Flex';
import { IconButton } from '../../../GlobalComponents/IconButton';
import { Modal, ModalProps } from '../../../GlobalComponents/Modal';
import { Title } from '../../../GlobalComponents/Title';
import { useAppSelector } from '../../../reduxstore/hooks';
import FavoriteProduct from './FavoriteProduct';

interface IPickFavoriteItemProps extends ModalProps {
	favoriteProducts: any;
	newItem: any;
}

export const PickFavoriteItem = ({
	isOpen,
	toggleHandler,
	favoriteProducts,
	newItem
}: IPickFavoriteItemProps): JSX.Element => {
	const userId = useAppSelector(state => state.authReducer.id);
	const dispatch = useDispatch();

	const [addFavoriteItem, { isLoading }] = useUpdateFavoritesInfoMutation();

	const productsArray = useMemo(() => {
		if (favoriteProducts !== undefined) {
			return [...favoriteProducts, newItem];
		}
		return [];
	}, [newItem, favoriteProducts]);

	const [selectedProducts, setSelectedProducts] = useState([
		...favoriteProducts
	]);

	const [showError, setShowError] = useState(false);

	const handleSelectProduct = (product: any) => {
		if (showError) {
			setShowError(false);
		}

		let newState = [...selectedProducts];

		// If new item already exists, remove it from selected list
		if (newState.find(el => el.product === product.product)) {
			newState = newState.filter(el => el.product !== product.product);

			setSelectedProducts(newState);
		} else {
			// in all other cases add it, deselect 1 existing if necessary
			if (newState.length >= 5) {
				newState.shift();
			}
			newState.push(product);

			setSelectedProducts(newState);
		}
	};

	const handleConfirmFavorites = () => {
		addFavoriteItem({
			id: userId,
			favorite_products: selectedProducts
		})
			.unwrap()
			.then((res: ProfileResponse) => {
				dispatch(setProfile(res.data.profile));
				dispatch(setBirthdaySet(res.data.birthday_set));
				toggleHandler();
			})
			.catch(() => setShowError(true));
	};

	return (
		<Modal isOpen={isOpen} toggleHandler={toggleHandler}>
			<Fragment>
				<Title>
					<Flex
						$flexDirection="row"
						$width="100%"
						$alignItems="center"
						$justifyContent="space-between"
					>
						Pick Your Favorites
						<IconButton
							url={CLOSE}
							alt="X"
							onClick={toggleHandler}
						/>
					</Flex>
				</Title>
				<p>
					It looks like you've selected too many favorite products.
					Pick the 5 you would like to keep!
				</p>
				{isLoading && <Loading />}
				<Flex
					$flexWrap="wrap"
					$justifyContent={'space-between'}
					$rowGap="12px"
				>
					{productsArray.map((el: any, i) => (
						<FavoriteProduct
							onClick={() => handleSelectProduct(el)}
							selected={selectedProducts.some(
								selectedProduct =>
									selectedProduct.product === el.product
							)}
							productId={el.product}
							productName={el.product_name}
							key={el.product_name + i}
						/>
					))}
				</Flex>
				<div className="float-right mt-4">
					<Button
						$buttonSize="small"
						onClick={handleConfirmFavorites}
					>
						CONFIRM
					</Button>
				</div>
				{showError && (
					<ErrorMessage message="We couldn't complete this request. Please try again later." />
				)}
			</Fragment>
		</Modal>
	);
};

export default PickFavoriteItem;

// const ItemNameText = styled.div<SelectedFavProps>`
// 	margin-top: 12px;
// 	font-size: 12px;
// 	font-weight: 700;
// 	overflow: hidden;
// 	text-overflow: ellipsis;
// 	display: -webkit-box;
// 	-webkit-line-clamp: 2;
// 	-webkit-box-orient: vertical;
// 	text-align: center;
// 	color: ${props => (props.selected ? '#f47920' : '#575757')};
// `;

// const FavoriteContainer = styled.div`
// 	padding: 10px;
// 	display: flex;
// 	flex-direction: column;
// 	align-items: center;
// 	cursor: pointer;
// `;
